import React from 'react';
import '../styles/About.css';
import aishwaryaJoshi from '../../assets/Aishwarya-2.png';
import clinicImage from '../../assets/saarthi-center-img.jpg';
import { HiOutlineMapPin, } from 'react-icons/hi2';
import { FaCrosshairs , FaHandshake } from 'react-icons/fa';
import { HiOutlineEye } from 'react-icons/hi';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <h1>About Saarthi Physiotherapy</h1>
        <p className="intro-text">
          Welcome to Saarthi Physiotherapy Center in Pune, where we are dedicated to <br /> providing high-quality, personalized physiotherapy care to help you recover, <br /> move, and live better.
        </p>

        <div className="section-grid">
          <div className="card-image">
            <img src={clinicImage} alt="Modern Clinic" />
            {/* <h3>Modern Clinic</h3> */}
          </div>
          <div className="card-text">
            <h2>Your Partner in Health and Recovery</h2>
            <p>
              At Saarthi, we believe in a holistic approach to healing. Our multidisciplinary team utilizes cutting-edge, tech-based treatments and evidence-backed scientific methods to ensure the best possible outcomes for our patients. Located conveniently in Pune, we are committed to restoring your movement and enhancing your overall well-being.
            </p>
            <p>
              We focus on individualized care plans, addressing the root cause of your discomfort and empowering you with the knowledge and tools for lasting recovery.
            </p>
          </div>
        </div>

        <div className="cards-row">
          <div className="card">
            <div className="icon-container">
            <FaCrosshairs className="card-icon" />
          </div>
            <h3>Our Mission</h3>
            <p>To empower individuals through evidence-based physiotherapy and innovative care that enhances well-being and restores movement.</p>
          </div>
          <div className="card">
            <div className="icon-container">
            <HiOutlineEye className="card-icon" />
          </div>
            <h3>Our Vision</h3>
            <p>To be the most trusted and advanced physiotherapy center, setting the benchmark for compassionate care and recovery-focused results.</p>
          </div>
          <div className="card">
            <div className="icon-container">
            <FaHandshake className="card-icon" />
          </div>
            <h3>Our Values</h3>
            <p>Integrity, Compassion, Innovation, Excellence, and Patient-Centered Care.</p>
          </div>
        </div>

        <div className="section-grid reverse">
          <div className="card-text">
            <h2>Meet Dr. Aishwarya Joshi</h2>
            <p>
              Saarthi Physiotherapy is proudly led by <b>Dr. Aishwarya Joshi</b>, a visionary physiotherapist dedicated to advancing patient care. With years of experience and a passion for integrating technology with traditional methods, Dr. Joshi ensures that every patient at Saarthi receives the most effective and personalized treatment.
            </p>
            <p>
              Dr. Joshi's commitment to continuous learning and patient advocacy is at the heart of our clinic's success, fostering an environment of healing and trust.
            </p>
          </div>
          <div className="card-image">
            <img src={aishwaryaJoshi} alt="Dr. Aishwarya Joshi" />
            <h3>Dr. Aishwarya Joshi</h3>
          </div>
        </div>

        <div className="map-section">
          <h2><HiOutlineMapPin className="location-icon" /> Find Us in Pune</h2>
          <div className="location-container">
            <p> Office no. 1, UpperGround Level, Fountainhead Society, Society, Baner - Balewadi Rd, opposite Bravuria Complex, Balewadi Phata, Balewadi, Pune, Maharashtra 411045</p>
          </div>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.108035113031!2d73.781425!3d18.5691675!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf96cd0321bb%3A0xa999801c96e618fb!2sSaarthi%20Physiotherapy%20Center!5e0!3m2!1sen!2sin!4v1744147061302!5m2!1sen!2sin"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Saarthi Physiotherapy Pune Location"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
